import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    nav_services: 'Services',
    nav_industries: 'Industries',
    nav_team: 'Team',
    nav_process: 'Process',
    nav_contact: 'Contact',
    nav_signin: 'Sign In',
    nav_client_portal: 'Client Portal',
    
    // Hero
    hero_badge: 'Trusted IT Partner in Montreal',
    hero_title_1: 'Expert Managed IT Services',
    hero_title_2: 'for Montreal Businesses',
    hero_description: 'Your business deserves robust cybersecurity, seamless cloud integration, and reliable IT support. Whitewick IT is your trusted partner for technology solutions in Canada.',
    hero_cta_portal: 'Access Client Portal',
    hero_cta_consultation: 'Get Free Consultation',
    
    // Services
    services_title: 'Comprehensive IT Solutions',
    services_description: 'We provide end-to-end technology services to help your business thrive in the digital age.',
    service_cybersecurity: 'Cybersecurity',
    service_cybersecurity_desc: 'Protect your business with advanced security solutions and threat monitoring.',
    service_cloud: 'Cloud Solutions',
    service_cloud_desc: 'Seamless cloud integration and migration for scalable infrastructure.',
    service_managed: 'Managed IT',
    service_managed_desc: 'Comprehensive IT management for a predictable monthly fee.',
    service_support: 'IT Support',
    service_support_desc: '24/7 technical support to keep your operations running smoothly.',
    service_cameras: 'Security Cameras',
    service_cameras_desc: 'Professional surveillance systems for complete property monitoring.',
    service_access: 'Access Control',
    service_access_desc: 'Building access control systems with keycard and biometric solutions.',
    service_voip: 'VoIP Phone Systems',
    service_voip_desc: 'Modern business phone systems with unified communications.',
    service_compliance: 'Compliance',
    service_compliance_desc: 'Navigate complex regulations with expert compliance guidance.',
    service_backup: 'Data Backup & Recovery',
    service_backup_desc: 'Reliable backup solutions and disaster recovery planning to protect your critical data.',
    service_network: 'Network Infrastructure',
    service_network_desc: 'Design, implementation, and management of robust network solutions for optimal connectivity.',
    service_datacenter: 'Data Center Operations',
    service_datacenter_desc: 'Professional data center management with monitoring, maintenance, and optimization.',
    service_desktop: 'Onsite Desktop Support',
    service_desktop_desc: 'Hands-on technical support at your location for hardware and software issues.',
    service_hosting: 'Specialized Hosting',
    service_hosting_desc: 'Custom hosting solutions tailored to your specific application and performance needs.',
    service_venue: 'Large Venue Solutions',
    service_venue_desc: 'Comprehensive IT infrastructure for museums, places of worship, banquet halls, and event spaces.',
    
    // Industries
    industries_title: 'Industry Expertise',
    industries_description: 'Specialized IT solutions tailored to your industry\'s unique requirements.',
    industry_law: 'Law Firms',
    industry_law_desc: 'Secure IT for legal practices',
    industry_accounting: 'Accounting',
    industry_accounting_desc: 'Financial data security',
    industry_medical: 'Medical Clinics',
    industry_medical_desc: 'HIPAA-compliant solutions',
    industry_retail: 'Retail',
    industry_retail_desc: 'POS & inventory systems',
    industry_hospitality: 'Hospitality & Food Service',
    industry_hospitality_desc: 'Restaurant & hotel IT solutions',
    industry_realestate: 'Real Estate',
    industry_realestate_desc: 'Property management systems',
    industry_events: 'Events & Entertainment',
    industry_events_desc: 'Event planners & venues',
    
    // Process
    process_title: 'Our Proven Process',
    process_description: 'A strategic approach to ensure your IT infrastructure is a powerful asset.',
    process_step1_title: 'Discovery',
    process_step1_desc: 'We analyze your current IT setup to identify risks and opportunities.',
    process_step2_title: 'Strategy',
    process_step2_desc: 'We design a custom IT solution tailored to your business needs.',
    process_step3_title: 'Implementation',
    process_step3_desc: 'We deploy and configure your new IT infrastructure.',
    process_step4_title: 'Support',
    process_step4_desc: 'Ongoing monitoring and support ensures optimal performance.',
    
    // Testimonial
    testimonial_quote: '"Jordan Whitewick is, by far, the best IT specialist I have ever had the pleasure of working with. Not only is he an expert in his field, but he is also a kind, patient, and understanding person."',
    testimonial_author: 'Johane O.',
    testimonial_role: 'Legal Professional, Montreal',
    
    // Contact
    contact_title: 'Ready to Elevate Your IT Strategy?',
    contact_description: 'Let\'s discuss how our managed IT services can empower your Montreal business. Contact us today for a no-obligation consultation.',
    contact_benefit1: 'Proactive monitoring & maintenance',
    contact_benefit2: 'Rapid response times',
    contact_benefit3: 'Flat-rate pricing with no surprises',
    contact_benefit4: 'Local Montreal-based support team',
    contact_form_title: 'Send us a message',
    contact_name: 'Name',
    contact_email: 'Email',
    contact_company: 'Company (optional)',
    contact_message: 'Message',
    contact_submit: 'Send Message',
    contact_sending: 'Sending...',
    contact_success: 'Message sent successfully! We\'ll get back to you shortly.',
    contact_error: 'Failed to send message. Please try again.',
    
    // Footer
    footer_rights: 'All rights reserved. Montreal, Canada.',
    footer_login: 'Client Login',
    
    // Auth
    auth_welcome_back: 'Welcome back',
    auth_signin_subtitle: 'Sign in to access your client portal',
    auth_email: 'Email',
    auth_password: 'Password',
    auth_signin: 'Sign in',
    auth_signing_in: 'Signing in...',
    auth_no_account: 'Don\'t have an account?',
    auth_create_one: 'Create one',
    auth_create_account: 'Create your account',
    auth_register_subtitle: 'Register to access the client portal',
    auth_full_name: 'Full Name',
    auth_company: 'Company',
    auth_phone: 'Phone (optional)',
    auth_min_password: 'Minimum 6 characters',
    auth_creating: 'Creating account...',
    auth_register: 'Create account',
    auth_have_account: 'Already have an account?',
    auth_signin_link: 'Sign in',
    auth_back_home: 'Back to home',
    
    // Dashboard
    dashboard_welcome: 'Welcome back',
    dashboard_overview: 'Here\'s an overview of your account activity.',
    dashboard_open_tickets: 'Open Tickets',
    dashboard_in_progress: 'in progress',
    dashboard_pending_invoices: 'Pending Invoices',
    dashboard_outstanding: 'CAD outstanding',
    dashboard_pending_quotes: 'Pending Quotes',
    dashboard_total_quotes: 'total quotes',
    dashboard_total_tickets: 'Total Tickets',
    dashboard_all_time: 'All time support requests',
    dashboard_quick_actions: 'Quick Actions',
    dashboard_create_ticket: 'Create Support Ticket',
    dashboard_view_invoices: 'View Invoices',
    dashboard_view_quotes: 'View Quotes',
    dashboard_account_settings: 'Account Settings',
    dashboard_recent_tickets: 'Recent Tickets',
    dashboard_view_all: 'View all',
    dashboard_no_tickets: 'No tickets yet',
    dashboard_create_first: 'Create your first ticket',
    dashboard_urgent_support: 'Need urgent support?',
    dashboard_urgent_desc: 'For critical issues, create a ticket with "Urgent" priority or contact us directly.',
    dashboard_new_ticket: 'New Ticket',
    
    // Tickets
    tickets_title: 'Support Tickets',
    tickets_subtitle: 'Manage your support requests',
    tickets_new: 'New Ticket',
    tickets_search: 'Search tickets...',
    tickets_all_status: 'All Status',
    tickets_open: 'Open',
    tickets_in_progress: 'In Progress',
    tickets_resolved: 'Resolved',
    tickets_closed: 'Closed',
    tickets_all_priority: 'All Priority',
    tickets_low: 'Low',
    tickets_medium: 'Medium',
    tickets_high: 'High',
    tickets_urgent: 'Urgent',
    tickets_no_tickets: 'No tickets found',
    tickets_adjust_filters: 'Try adjusting your filters',
    tickets_create_first: 'Create your first support ticket to get help',
    tickets_create: 'Create Ticket',
    tickets_showing: 'Showing',
    tickets_of: 'of',
    tickets_tickets: 'tickets',
    
    // Create Ticket
    create_ticket_title: 'Create Support Ticket',
    create_ticket_subtitle: 'Submit a new support request to our team',
    create_ticket_back: 'Back to Tickets',
    create_ticket_field_title: 'Title',
    create_ticket_title_placeholder: 'Brief summary of your issue',
    create_ticket_category: 'Category',
    create_ticket_select_category: 'Select category',
    create_ticket_priority: 'Priority',
    create_ticket_description: 'Description',
    create_ticket_description_placeholder: 'Please provide as much detail as possible about your issue, including:\n- Steps to reproduce the problem\n- Any error messages\n- What you expected to happen',
    create_ticket_tip: 'The more details you provide, the faster we can resolve your issue. Include relevant screenshots, error codes, or system information if applicable.',
    create_ticket_cancel: 'Cancel',
    create_ticket_submit: 'Submit Ticket',
    create_ticket_creating: 'Creating...',
    
    // Categories
    category_technical: 'Technical Support',
    category_network: 'Network Issues',
    category_hardware: 'Hardware',
    category_software: 'Software',
    category_security: 'Security',
    category_cloud: 'Cloud Services',
    category_account: 'Account / Billing',
    category_other: 'Other',
    
    // Priorities
    priority_low_desc: 'Minor issue, no business impact',
    priority_medium_desc: 'Moderate impact, workaround available',
    priority_high_desc: 'Significant impact on operations',
    priority_urgent_desc: 'Critical - business stopped',
    
    // Ticket Detail
    ticket_back: 'Back to Tickets',
    ticket_description: 'Description',
    ticket_update_status: 'Update Status',
    ticket_update: 'Update Status',
    ticket_updating: 'Updating...',
    ticket_status_note: 'Note: In production, status updates would sync with your GLPI system.',
    ticket_details: 'Details',
    ticket_category: 'Category',
    ticket_priority: 'Priority',
    ticket_status: 'Status',
    ticket_timeline: 'Timeline',
    ticket_created: 'Ticket Created',
    ticket_last_updated: 'Last Updated',
    ticket_need_help: 'Need urgent assistance? Contact our support team directly.',
    ticket_contact_support: 'Contact Support',
    
    // Invoices
    invoices_title: 'Invoices',
    invoices_subtitle: 'View and manage your invoices',
    invoices_total: 'Total Invoices',
    invoices_outstanding: 'Outstanding',
    invoices_total_paid: 'Total Paid',
    invoices_history: 'Invoice History',
    invoices_no_invoices: 'No invoices yet',
    invoices_will_appear: 'Your invoices will appear here once generated.',
    invoices_number: 'Invoice #',
    invoices_description: 'Description',
    invoices_issued: 'Issued',
    invoices_due_date: 'Due Date',
    invoices_amount: 'Amount',
    invoices_status: 'Status',
    invoices_actions: 'Actions',
    
    // Quotes
    quotes_title: 'Quotes & Proposals',
    quotes_subtitle: 'Review your quotes and proposals',
    quotes_total: 'Total Quotes',
    quotes_pending_value: 'Pending Value',
    quotes_accepted_value: 'Accepted Value',
    quotes_no_quotes: 'No quotes yet',
    quotes_will_appear: 'Your quotes and proposals will appear here.',
    quotes_view_details: 'View Details',
    quotes_accept: 'Accept Quote',
    quotes_created: 'Created',
    quotes_valid_until: 'Valid until',
    
    // Account
    account_title: 'Account Settings',
    account_subtitle: 'Manage your account and company information',
    account_company_info: 'Company Information',
    account_company_name: 'Company Name',
    account_contact_name: 'Contact Name',
    account_phone: 'Phone',
    account_address: 'Address',
    account_city: 'City / Province',
    account_country: 'Country',
    account_save: 'Save Changes',
    account_saving: 'Saving...',
    account_user_profile: 'User Profile',
    account_status: 'Account Status',
    account_active: 'Active',
    account_member_since: 'Member since',
    account_sync_note: 'Your account information is synced with Dolibarr. Changes made here will update your client record.',
    
    // Sidebar
    sidebar_dashboard: 'Dashboard',
    sidebar_tickets: 'Support Tickets',
    sidebar_interventions: 'Interventions',
    sidebar_network: 'Network',
    sidebar_racks: 'Server Racks',
    sidebar_maintenance: 'Maintenance Notices',
    sidebar_assessments: 'Assessments',
    sidebar_invoices: 'Invoices',
    sidebar_quotes: 'Quotes',
    sidebar_proposals: 'Proposals',
    sidebar_messages: 'Messages',
    sidebar_changes: 'Changes',
    sidebar_onboarding: 'Onboarding',
    sidebar_files: 'Files',
    sidebar_kb: 'Knowledge Base',
    sidebar_ipam: 'IPAM',
    sidebar_assets: 'Assets',
    sidebar_faq: 'Help Center',
    sidebar_notifications: 'Notifications',
    sidebar_emails: 'Emails',
    sidebar_contracts: 'Contracts',
    sidebar_quotes: 'Quotes',
    sidebar_service_catalog: 'Service Catalog',
    sidebar_hours: 'Hours Usage',
    sidebar_expenses: 'Expenses',
    sidebar_team: 'Team',
    sidebar_account: 'Account',
    sidebar_signout: 'Sign out',
    
    // Team Management
    team_title: 'Team Management',
    team_subtitle: 'Manage users for',
    team_add_member: 'Add Team Member',
    team_total_members: 'Total Members',
    team_managers: 'Managers',
    team_active_members: 'Active Members',
    team_member: 'Member',
    team_role: 'Role',
    team_language: 'Language',
    team_status: 'Status',
    team_actions: 'Actions',
    team_manager: 'Manager',
    team_user: 'User',
    team_active: 'Active',
    team_inactive: 'Inactive',
    team_you: 'You',
    team_edit: 'Edit',
    team_edit_permissions: 'Edit Permissions',
    team_deactivate: 'Deactivate',
    team_activate: 'Activate',
    team_no_members: 'No team members found',
    team_full_name: 'Full Name',
    team_full_name_placeholder: 'John Smith',
    team_email: 'Email',
    team_password: 'Password',
    team_password_placeholder: 'Minimum 6 characters',
    team_password_hint: 'The user will receive this password via email',
    team_phone: 'Phone',
    team_make_manager: 'Make Manager',
    team_new_member_info: 'A welcome email with login credentials will be sent to the new team member.',
    team_cancel: 'Cancel',
    team_create: 'Create Member',
    team_save: 'Save Changes',
    team_edit_member: 'Edit Team Member',
    team_email_readonly: 'Email cannot be changed',
    team_permissions_for: 'Permissions for',
    team_perm_own_tickets: 'View Own Tickets Only',
    team_perm_own_tickets_desc: 'If OFF, can view all company tickets',
    team_perm_create_tickets: 'Can Create Tickets',
    team_perm_modify_tickets: 'Can Modify Tickets',
    team_perm_view_invoices: 'Can View Invoices',
    team_perm_view_proposals: 'Can View Proposals',
    team_perm_accept_proposals: 'Can Accept Proposals',
    team_perm_readonly: 'Read-Only Mode',
    team_perm_readonly_desc: 'Overrides all to view-only',
    team_save_permissions: 'Save Permissions',
    team_access_denied: 'Access Denied',
    team_manager_only: 'Only managers can access team management.',
    team_not_manager: 'Only managers can access team management',
    team_fetch_error: 'Failed to load team members',
    team_fill_required: 'Please fill all required fields',
    team_password_min: 'Password must be at least 6 characters',
    team_member_created: 'Team member created successfully',
    team_create_error: 'Failed to create team member',
    team_member_updated: 'Team member updated successfully',
    team_update_error: 'Failed to update team member',
    team_permissions_updated: 'Permissions updated successfully',
    team_member_deactivated: 'Team member deactivated',
    team_member_activated: 'Team member activated',
    
    // Notifications
    notif_page_title: 'Notification Settings',
    notif_page_desc: 'Manage how you receive notifications',
    notif_push_title: 'Push Notifications',
    notif_push_desc: 'Receive instant notifications on your device',
    notif_push_enabled: 'Enabled',
    notif_push_disabled: 'Disabled',
    notif_push_will_receive: 'You will receive push notifications',
    notif_push_enable_prompt: 'Enable to receive instant alerts',
    notif_push_not_supported: 'Push notifications are not supported on this device/browser',
    notif_push_blocked: 'Notifications Blocked',
    notif_push_blocked_desc: 'Enable notifications in your browser settings to receive alerts',
    notif_prefs_title: 'Notification Preferences',
    notif_prefs_desc: 'Choose which notifications you want to receive',
    notif_ticket_updates: 'Ticket Updates',
    notif_ticket_updates_desc: 'When your ticket status changes',
    notif_ticket_resolved: 'Ticket Resolved',
    notif_ticket_resolved_desc: 'When your ticket is resolved',
    notif_new_messages: 'New Messages',
    notif_new_messages_desc: 'When you receive a new message',
    notif_warranty_alerts: 'Warranty Alerts',
    notif_warranty_alerts_desc: 'When asset warranties are expiring',
    notif_new_tickets: 'New Tickets',
    notif_new_tickets_desc: 'When a new support ticket is created',
    notif_high_priority: 'High Priority Tickets',
    notif_high_priority_desc: 'Urgent and high priority tickets',
    notif_sla_warnings: 'SLA Warnings',
    notif_sla_warnings_desc: 'When tickets are approaching SLA breach',
    notif_new_customers: 'New Customers',
    notif_new_customers_desc: 'When a new customer registers',
    notif_client_messages: 'Client Messages',
    notif_client_messages_desc: 'When clients send messages',
    notif_system_alerts: 'System Alerts',
    notif_system_alerts_desc: 'Integration errors and system issues',
    
    // Push Admin
    push_admin_title: 'Push Notifications',
    push_admin_desc: 'Manage and monitor push notifications',
    push_send_btn: 'Send Notification',
    push_refresh: 'Refresh',
    push_total_subs: 'Total Subscribers',
    push_sent_today: 'Sent Today',
    push_this_week: 'This Week',
    push_failed: 'Failed',
    push_status: 'Status',
    push_user_type: 'User Type',
    push_clear_logs: 'Clear Old Logs',
    push_log_title: 'Notification Log',
    push_no_logs: 'No notification logs found',
    push_vapid_warning: 'VAPID Keys Not Configured',
    push_vapid_warning_desc: 'Push notifications are being logged but not sent. Add VAPID_PUBLIC_KEY and VAPID_PRIVATE_KEY to your environment variables.',
    push_send_title: 'Send Push Notification',
    push_title: 'Title',
    push_message: 'Message',
    push_link_url: 'Link URL',
    push_target: 'Target',
    push_target_all: 'All Subscribers',
    push_target_company: 'Specific Company',
    push_target_user: 'Specific User',
    push_sending: 'Sending...',
    
    // Careers
    careers_join: 'Join Our Team',
    careers_title: 'Careers at Whitewick IT',
    careers_subtitle: 'Build your career with a passionate team redefining IT services for businesses across Canada.',
    careers_life_title: 'Life at Whitewick IT',
    careers_life_subtitle: 'We believe great people build great solutions. Here\'s why our team loves working here.',
    careers_positions_title: 'Open Positions',
    careers_positions_count: 'open position',
    careers_positions_count_plural: 'open positions',
    careers_no_positions: 'No open positions at the moment.',
    careers_no_positions_detail: 'No open positions right now, but check back soon!',
    careers_perk_health: 'Health & Wellness',
    careers_perk_health_desc: 'Comprehensive health, dental, and vision coverage for you and your family.',
    careers_perk_growth: 'Growth & Learning',
    careers_perk_growth_desc: 'Annual professional development budget and certifications supported.',
    careers_perk_flex: 'Flexible Work',
    careers_perk_flex_desc: 'Hybrid and remote options with flexible hours to suit your lifestyle.',
    careers_perk_balance: 'Work-Life Balance',
    careers_perk_balance_desc: 'Generous PTO, paid holidays, and wellness days.',
    careers_perk_team: 'Great Team',
    careers_perk_team_desc: 'Collaborative, supportive team with regular social events.',
    careers_perk_pay: 'Competitive Pay',
    careers_perk_pay_desc: 'Market-leading compensation with annual reviews and bonuses.',
    careers_job_full_time: 'Full-Time',
    careers_job_part_time: 'Part-Time',
    careers_job_contract: 'Contract',
    careers_job_internship: 'Internship',
    careers_description: 'Description',
    careers_requirements: 'Requirements',
    careers_benefits: 'Benefits',
    careers_close: 'Close',
    careers_apply_now: 'Apply Now',
    careers_apply: 'Apply',
    careers_submitted: 'Application Submitted!',
    careers_thank_you: 'Thank you for your application!',
    careers_confirm_email: 'We\'ve sent a confirmation email. Our team will review your application shortly.',
    careers_full_name: 'Full Name',
    careers_phone: 'Phone',
    careers_cv: 'CV / Resume',
    careers_cv_upload: 'Upload CV (PDF, DOC, DOCX - max 10MB)',
    careers_cv_required: 'Please upload your CV',
    careers_cover_letter: 'Cover Letter (optional)',
    careers_cover_letter_upload: 'Upload cover letter file (optional)',
    careers_message: 'Additional Message (optional)',
    careers_message_placeholder: 'Tell us why you\'re interested in this role...',
    careers_submit: 'Submit Application',
    careers_submitting: 'Submitting...',
    careers_success: 'Application submitted successfully!',
    careers_error: 'Failed to submit application',
    careers_error_generic: 'Error submitting application',
    careers_name_email_required: 'Name and email are required',
    careers_footer: 'All rights reserved.',

    // Common
    common_loading: 'Loading...',
    common_error: 'An error occurred',
    common_success: 'Success',
    common_cancel: 'Cancel',
    common_save: 'Save',
    common_delete: 'Delete',
    common_edit: 'Edit',
    common_view: 'View',
    common_required: 'Required',
  },
  fr: {
    // Navigation
    nav_services: 'Services',
    nav_industries: 'Industries',
    nav_team: 'Équipe',
    nav_process: 'Processus',
    nav_contact: 'Contact',
    nav_signin: 'Connexion',
    nav_client_portal: 'Portail Client',
    
    // Hero
    hero_badge: 'Partenaire TI de confiance à Montréal',
    hero_title_1: 'Services TI Gérés Experts',
    hero_title_2: 'pour les Entreprises de Montréal',
    hero_description: 'Votre entreprise mérite une cybersécurité robuste, une intégration cloud transparente et un support informatique fiable. Whitewick IT est votre partenaire de confiance pour les solutions technologiques au Canada.',
    hero_cta_portal: 'Accéder au Portail Client',
    hero_cta_consultation: 'Consultation Gratuite',
    
    // Services
    services_title: 'Solutions TI Complètes',
    services_description: 'Nous fournissons des services technologiques de bout en bout pour aider votre entreprise à prospérer à l\'ère numérique.',
    service_cybersecurity: 'Cybersécurité',
    service_cybersecurity_desc: 'Protégez votre entreprise avec des solutions de sécurité avancées et une surveillance des menaces.',
    service_cloud: 'Solutions Cloud',
    service_cloud_desc: 'Intégration et migration cloud transparentes pour une infrastructure évolutive.',
    service_managed: 'TI Gérés',
    service_managed_desc: 'Gestion TI complète pour un frais mensuel prévisible.',
    service_support: 'Support TI',
    service_support_desc: 'Support technique 24/7 pour assurer le bon fonctionnement de vos opérations.',
    service_cameras: 'Caméras de Sécurité',
    service_cameras_desc: 'Systèmes de surveillance professionnels pour une surveillance complète de vos locaux.',
    service_access: 'Contrôle d\'Accès',
    service_access_desc: 'Systèmes de contrôle d\'accès aux bâtiments avec cartes et solutions biométriques.',
    service_voip: 'Téléphonie VoIP',
    service_voip_desc: 'Systèmes téléphoniques d\'entreprise modernes avec communications unifiées.',
    service_compliance: 'Conformité',
    service_compliance_desc: 'Naviguez dans les réglementations complexes avec des conseils experts en conformité.',
    service_backup: 'Sauvegarde & Récupération',
    service_backup_desc: 'Solutions de sauvegarde fiables et planification de reprise après sinistre pour protéger vos données critiques.',
    service_network: 'Infrastructure Réseau',
    service_network_desc: 'Conception, mise en œuvre et gestion de solutions réseau robustes pour une connectivité optimale.',
    service_datacenter: 'Opérations Data Center',
    service_datacenter_desc: 'Gestion professionnelle de centres de données avec surveillance, maintenance et optimisation.',
    service_desktop: 'Support Bureau Sur Site',
    service_desktop_desc: 'Support technique pratique sur votre site pour les problèmes matériels et logiciels.',
    service_hosting: 'Hébergement Spécialisé',
    service_hosting_desc: 'Solutions d\'hébergement personnalisées adaptées à vos besoins d\'applications et de performance.',
    service_venue: 'Solutions Grands Espaces',
    service_venue_desc: 'Infrastructure TI complète pour musées, lieux de culte, salles de réception et espaces événementiels.',
    
    // Industries
    industries_title: 'Expertise Sectorielle',
    industries_description: 'Solutions TI spécialisées adaptées aux exigences uniques de votre industrie.',
    industry_law: 'Cabinets d\'Avocats',
    industry_law_desc: 'TI sécurisées pour les pratiques juridiques',
    industry_accounting: 'Comptabilité',
    industry_accounting_desc: 'Sécurité des données financières',
    industry_medical: 'Cliniques Médicales',
    industry_medical_desc: 'Solutions conformes HIPAA',
    industry_retail: 'Commerce de Détail',
    industry_retail_desc: 'Systèmes PDV et inventaire',
    industry_hospitality: 'Hôtellerie & Restauration',
    industry_hospitality_desc: 'Solutions TI restaurants et hôtels',
    industry_realestate: 'Immobilier',
    industry_realestate_desc: 'Systèmes de gestion immobilière',
    industry_events: 'Événementiel & Divertissement',
    industry_events_desc: 'Organisateurs d\'événements et salles',
    
    // Process
    process_title: 'Notre Processus Éprouvé',
    process_description: 'Une approche stratégique pour garantir que votre infrastructure TI soit un atout puissant.',
    process_step1_title: 'Découverte',
    process_step1_desc: 'Nous analysons votre configuration TI actuelle pour identifier les risques et opportunités.',
    process_step2_title: 'Stratégie',
    process_step2_desc: 'Nous concevons une solution TI personnalisée adaptée à vos besoins.',
    process_step3_title: 'Mise en Œuvre',
    process_step3_desc: 'Nous déployons et configurons votre nouvelle infrastructure TI.',
    process_step4_title: 'Support',
    process_step4_desc: 'Une surveillance et un support continus assurent des performances optimales.',
    
    // Testimonial
    testimonial_quote: '"Jordan Whitewick est, de loin, le meilleur spécialiste TI avec qui j\'ai eu le plaisir de travailler. Non seulement est-il un expert dans son domaine, mais il est aussi une personne gentille, patiente et compréhensive."',
    testimonial_author: 'Johane O.',
    testimonial_role: 'Professionnelle Juridique, Montréal',
    
    // Contact
    contact_title: 'Prêt à Élever Votre Stratégie TI?',
    contact_description: 'Discutons de la façon dont nos services TI gérés peuvent renforcer votre entreprise montréalaise. Contactez-nous aujourd\'hui pour une consultation sans obligation.',
    contact_benefit1: 'Surveillance et maintenance proactives',
    contact_benefit2: 'Temps de réponse rapides',
    contact_benefit3: 'Tarification forfaitaire sans surprises',
    contact_benefit4: 'Équipe de support locale à Montréal',
    contact_form_title: 'Envoyez-nous un message',
    contact_name: 'Nom',
    contact_email: 'Courriel',
    contact_company: 'Entreprise (optionnel)',
    contact_message: 'Message',
    contact_submit: 'Envoyer le Message',
    contact_sending: 'Envoi en cours...',
    contact_success: 'Message envoyé avec succès! Nous vous répondrons sous peu.',
    contact_error: 'Échec de l\'envoi du message. Veuillez réessayer.',
    
    // Footer
    footer_rights: 'Tous droits réservés. Montréal, Canada.',
    footer_login: 'Connexion Client',
    
    // Auth
    auth_welcome_back: 'Bienvenue',
    auth_signin_subtitle: 'Connectez-vous pour accéder à votre portail client',
    auth_email: 'Courriel',
    auth_password: 'Mot de passe',
    auth_signin: 'Connexion',
    auth_signing_in: 'Connexion en cours...',
    auth_no_account: 'Vous n\'avez pas de compte?',
    auth_create_one: 'Créez-en un',
    auth_create_account: 'Créez votre compte',
    auth_register_subtitle: 'Inscrivez-vous pour accéder au portail client',
    auth_full_name: 'Nom Complet',
    auth_company: 'Entreprise',
    auth_phone: 'Téléphone (optionnel)',
    auth_min_password: 'Minimum 6 caractères',
    auth_creating: 'Création du compte...',
    auth_register: 'Créer le compte',
    auth_have_account: 'Vous avez déjà un compte?',
    auth_signin_link: 'Connectez-vous',
    auth_back_home: 'Retour à l\'accueil',
    
    // Dashboard
    dashboard_welcome: 'Bienvenue',
    dashboard_overview: 'Voici un aperçu de l\'activité de votre compte.',
    dashboard_open_tickets: 'Tickets Ouverts',
    dashboard_in_progress: 'en cours',
    dashboard_pending_invoices: 'Factures en Attente',
    dashboard_outstanding: 'CAD en souffrance',
    dashboard_pending_quotes: 'Devis en Attente',
    dashboard_total_quotes: 'devis au total',
    dashboard_total_tickets: 'Total des Tickets',
    dashboard_all_time: 'Toutes les demandes de support',
    dashboard_quick_actions: 'Actions Rapides',
    dashboard_create_ticket: 'Créer un Ticket de Support',
    dashboard_view_invoices: 'Voir les Factures',
    dashboard_view_quotes: 'Voir les Devis',
    dashboard_account_settings: 'Paramètres du Compte',
    dashboard_recent_tickets: 'Tickets Récents',
    dashboard_view_all: 'Voir tout',
    dashboard_no_tickets: 'Aucun ticket',
    dashboard_create_first: 'Créez votre premier ticket',
    dashboard_urgent_support: 'Besoin d\'un support urgent?',
    dashboard_urgent_desc: 'Pour les problèmes critiques, créez un ticket avec priorité "Urgente" ou contactez-nous directement.',
    dashboard_new_ticket: 'Nouveau Ticket',
    
    // Tickets
    tickets_title: 'Tickets de Support',
    tickets_subtitle: 'Gérez vos demandes de support',
    tickets_new: 'Nouveau Ticket',
    tickets_search: 'Rechercher des tickets...',
    tickets_all_status: 'Tous les Statuts',
    tickets_open: 'Ouvert',
    tickets_in_progress: 'En Cours',
    tickets_resolved: 'Résolu',
    tickets_closed: 'Fermé',
    tickets_all_priority: 'Toutes les Priorités',
    tickets_low: 'Basse',
    tickets_medium: 'Moyenne',
    tickets_high: 'Haute',
    tickets_urgent: 'Urgente',
    tickets_no_tickets: 'Aucun ticket trouvé',
    tickets_adjust_filters: 'Essayez d\'ajuster vos filtres',
    tickets_create_first: 'Créez votre premier ticket de support pour obtenir de l\'aide',
    tickets_create: 'Créer un Ticket',
    tickets_showing: 'Affichage de',
    tickets_of: 'sur',
    tickets_tickets: 'tickets',
    
    // Create Ticket
    create_ticket_title: 'Créer un Ticket de Support',
    create_ticket_subtitle: 'Soumettez une nouvelle demande de support à notre équipe',
    create_ticket_back: 'Retour aux Tickets',
    create_ticket_field_title: 'Titre',
    create_ticket_title_placeholder: 'Résumé bref de votre problème',
    create_ticket_category: 'Catégorie',
    create_ticket_select_category: 'Sélectionner une catégorie',
    create_ticket_priority: 'Priorité',
    create_ticket_description: 'Description',
    create_ticket_description_placeholder: 'Veuillez fournir autant de détails que possible sur votre problème, y compris:\n- Étapes pour reproduire le problème\n- Messages d\'erreur\n- Ce que vous attendiez',
    create_ticket_tip: 'Plus vous fournissez de détails, plus vite nous pourrons résoudre votre problème. Incluez des captures d\'écran, codes d\'erreur ou informations système pertinentes si applicable.',
    create_ticket_cancel: 'Annuler',
    create_ticket_submit: 'Soumettre le Ticket',
    create_ticket_creating: 'Création...',
    
    // Categories
    category_technical: 'Support Technique',
    category_network: 'Problèmes Réseau',
    category_hardware: 'Matériel',
    category_software: 'Logiciel',
    category_security: 'Sécurité',
    category_cloud: 'Services Cloud',
    category_account: 'Compte / Facturation',
    category_other: 'Autre',
    
    // Priorities
    priority_low_desc: 'Problème mineur, pas d\'impact sur l\'entreprise',
    priority_medium_desc: 'Impact modéré, solution de contournement disponible',
    priority_high_desc: 'Impact significatif sur les opérations',
    priority_urgent_desc: 'Critique - entreprise arrêtée',
    
    // Ticket Detail
    ticket_back: 'Retour aux Tickets',
    ticket_description: 'Description',
    ticket_update_status: 'Mettre à Jour le Statut',
    ticket_update: 'Mettre à Jour',
    ticket_updating: 'Mise à jour...',
    ticket_status_note: 'Note: En production, les mises à jour de statut seraient synchronisées avec votre système GLPI.',
    ticket_details: 'Détails',
    ticket_category: 'Catégorie',
    ticket_priority: 'Priorité',
    ticket_status: 'Statut',
    ticket_timeline: 'Chronologie',
    ticket_created: 'Ticket Créé',
    ticket_last_updated: 'Dernière Mise à Jour',
    ticket_need_help: 'Besoin d\'une assistance urgente? Contactez directement notre équipe de support.',
    ticket_contact_support: 'Contacter le Support',
    
    // Invoices
    invoices_title: 'Factures',
    invoices_subtitle: 'Consultez et gérez vos factures',
    invoices_total: 'Total des Factures',
    invoices_outstanding: 'En Souffrance',
    invoices_total_paid: 'Total Payé',
    invoices_history: 'Historique des Factures',
    invoices_no_invoices: 'Aucune facture',
    invoices_will_appear: 'Vos factures apparaîtront ici une fois générées.',
    invoices_number: 'Facture #',
    invoices_description: 'Description',
    invoices_issued: 'Émise',
    invoices_due_date: 'Échéance',
    invoices_amount: 'Montant',
    invoices_status: 'Statut',
    invoices_actions: 'Actions',
    
    // Quotes
    quotes_title: 'Devis et Propositions',
    quotes_subtitle: 'Consultez vos devis et propositions',
    quotes_total: 'Total des Devis',
    quotes_pending_value: 'Valeur en Attente',
    quotes_accepted_value: 'Valeur Acceptée',
    quotes_no_quotes: 'Aucun devis',
    quotes_will_appear: 'Vos devis et propositions apparaîtront ici.',
    quotes_view_details: 'Voir les Détails',
    quotes_accept: 'Accepter le Devis',
    quotes_created: 'Créé',
    quotes_valid_until: 'Valide jusqu\'au',
    
    // Account
    account_title: 'Paramètres du Compte',
    account_subtitle: 'Gérez les informations de votre compte et entreprise',
    account_company_info: 'Informations de l\'Entreprise',
    account_company_name: 'Nom de l\'Entreprise',
    account_contact_name: 'Nom du Contact',
    account_phone: 'Téléphone',
    account_address: 'Adresse',
    account_city: 'Ville / Province',
    account_country: 'Pays',
    account_save: 'Enregistrer les Modifications',
    account_saving: 'Enregistrement...',
    account_user_profile: 'Profil Utilisateur',
    account_status: 'Statut du Compte',
    account_active: 'Actif',
    account_member_since: 'Membre depuis',
    account_sync_note: 'Les informations de votre compte sont synchronisées avec Dolibarr. Les modifications effectuées ici mettront à jour votre dossier client.',
    
    // Sidebar
    sidebar_dashboard: 'Tableau de Bord',
    sidebar_tickets: 'Tickets de Support',
    sidebar_interventions: 'Interventions',
    sidebar_network: 'Réseau',
    sidebar_racks: 'Racks Serveur',
    sidebar_maintenance: 'Avis de maintenance',
    sidebar_assessments: 'Évaluations',
    sidebar_invoices: 'Factures',
    sidebar_quotes: 'Devis',
    sidebar_proposals: 'Propositions',
    sidebar_messages: 'Messages',
    sidebar_changes: 'Changements',
    sidebar_onboarding: 'Intégration',
    sidebar_files: 'Fichiers',
    sidebar_kb: 'Base de Connaissances',
    sidebar_ipam: 'IPAM',
    sidebar_assets: 'Assets',
    sidebar_faq: 'Centre d\'aide',
    sidebar_notifications: 'Notifications',
    sidebar_emails: 'Courriels',
    sidebar_contracts: 'Contrats',
    sidebar_quotes: 'Soumissions',
    sidebar_service_catalog: 'Catalogue de Services',
    sidebar_hours: 'Utilisation des Heures',
    sidebar_expenses: 'Depenses',
    sidebar_team: 'Équipe',
    sidebar_account: 'Compte',
    sidebar_signout: 'Déconnexion',
    
    // Team Management
    team_title: 'Gestion d\'Équipe',
    team_subtitle: 'Gérer les utilisateurs pour',
    team_add_member: 'Ajouter un Membre',
    team_total_members: 'Total des Membres',
    team_managers: 'Gestionnaires',
    team_active_members: 'Membres Actifs',
    team_member: 'Membre',
    team_role: 'Rôle',
    team_language: 'Langue',
    team_status: 'Statut',
    team_actions: 'Actions',
    team_manager: 'Gestionnaire',
    team_user: 'Utilisateur',
    team_active: 'Actif',
    team_inactive: 'Inactif',
    team_you: 'Vous',
    team_edit: 'Modifier',
    team_edit_permissions: 'Modifier les Permissions',
    team_deactivate: 'Désactiver',
    team_activate: 'Activer',
    team_no_members: 'Aucun membre trouvé',
    team_full_name: 'Nom Complet',
    team_full_name_placeholder: 'Jean Dupont',
    team_email: 'Courriel',
    team_password: 'Mot de passe',
    team_password_placeholder: 'Minimum 6 caractères',
    team_password_hint: 'L\'utilisateur recevra ce mot de passe par courriel',
    team_phone: 'Téléphone',
    team_make_manager: 'Rendre Gestionnaire',
    team_new_member_info: 'Un courriel de bienvenue avec les identifiants sera envoyé au nouveau membre.',
    team_cancel: 'Annuler',
    team_create: 'Créer le Membre',
    team_save: 'Enregistrer',
    team_edit_member: 'Modifier le Membre',
    team_email_readonly: 'Le courriel ne peut pas être modifié',
    team_permissions_for: 'Permissions pour',
    team_perm_own_tickets: 'Voir Ses Propres Tickets',
    team_perm_own_tickets_desc: 'Si désactivé, peut voir tous les tickets de l\'entreprise',
    team_perm_create_tickets: 'Peut Créer des Tickets',
    team_perm_modify_tickets: 'Peut Modifier des Tickets',
    team_perm_view_invoices: 'Peut Voir les Factures',
    team_perm_view_proposals: 'Peut Voir les Propositions',
    team_perm_accept_proposals: 'Peut Accepter les Propositions',
    team_perm_readonly: 'Mode Lecture Seule',
    team_perm_readonly_desc: 'Annule tout pour lecture seule',
    team_save_permissions: 'Enregistrer les Permissions',
    team_access_denied: 'Accès Refusé',
    team_manager_only: 'Seuls les gestionnaires peuvent accéder à la gestion d\'équipe.',
    team_not_manager: 'Seuls les gestionnaires peuvent accéder à la gestion d\'équipe',
    team_fetch_error: 'Échec du chargement des membres',
    team_fill_required: 'Veuillez remplir tous les champs requis',
    team_password_min: 'Le mot de passe doit contenir au moins 6 caractères',
    team_member_created: 'Membre créé avec succès',
    team_create_error: 'Échec de la création du membre',
    team_member_updated: 'Membre mis à jour avec succès',
    team_update_error: 'Échec de la mise à jour du membre',
    team_permissions_updated: 'Permissions mises à jour avec succès',
    team_member_deactivated: 'Membre désactivé',
    team_member_activated: 'Membre activé',
    
    // Notifications
    notif_page_title: 'Paramètres de Notifications',
    notif_page_desc: 'Gérez comment vous recevez les notifications',
    notif_push_title: 'Notifications Push',
    notif_push_desc: 'Recevez des notifications instantanées sur votre appareil',
    notif_push_enabled: 'Activé',
    notif_push_disabled: 'Désactivé',
    notif_push_will_receive: 'Vous recevrez des notifications push',
    notif_push_enable_prompt: 'Activer pour recevoir des alertes instantanées',
    notif_push_not_supported: 'Les notifications push ne sont pas prises en charge sur cet appareil/navigateur',
    notif_push_blocked: 'Notifications Bloquées',
    notif_push_blocked_desc: 'Activez les notifications dans les paramètres de votre navigateur pour recevoir des alertes',
    notif_prefs_title: 'Préférences de Notifications',
    notif_prefs_desc: 'Choisissez les notifications que vous souhaitez recevoir',
    notif_ticket_updates: 'Mises à jour des Tickets',
    notif_ticket_updates_desc: 'Lorsque le statut de votre ticket change',
    notif_ticket_resolved: 'Ticket Résolu',
    notif_ticket_resolved_desc: 'Lorsque votre ticket est résolu',
    notif_new_messages: 'Nouveaux Messages',
    notif_new_messages_desc: 'Lorsque vous recevez un nouveau message',
    notif_warranty_alerts: 'Alertes de Garantie',
    notif_warranty_alerts_desc: 'Lorsque les garanties des actifs expirent',
    notif_new_tickets: 'Nouveaux Tickets',
    notif_new_tickets_desc: 'Lorsqu\'un nouveau ticket de support est créé',
    notif_high_priority: 'Tickets Haute Priorité',
    notif_high_priority_desc: 'Tickets urgents et haute priorité',
    notif_sla_warnings: 'Avertissements SLA',
    notif_sla_warnings_desc: 'Lorsque les tickets approchent d\'une violation SLA',
    notif_new_customers: 'Nouveaux Clients',
    notif_new_customers_desc: 'Lorsqu\'un nouveau client s\'inscrit',
    notif_client_messages: 'Messages Clients',
    notif_client_messages_desc: 'Lorsque les clients envoient des messages',
    notif_system_alerts: 'Alertes Système',
    notif_system_alerts_desc: 'Erreurs d\'intégration et problèmes système',
    
    // Push Admin
    push_admin_title: 'Notifications Push',
    push_admin_desc: 'Gérez et surveillez les notifications push',
    push_send_btn: 'Envoyer une Notification',
    push_refresh: 'Actualiser',
    push_total_subs: 'Total Abonnés',
    push_sent_today: 'Envoyées Aujourd\'hui',
    push_this_week: 'Cette Semaine',
    push_failed: 'Échouées',
    push_status: 'Statut',
    push_user_type: 'Type d\'Utilisateur',
    push_clear_logs: 'Effacer Anciens Logs',
    push_log_title: 'Journal des Notifications',
    push_no_logs: 'Aucun journal de notifications trouvé',
    push_vapid_warning: 'Clés VAPID Non Configurées',
    push_vapid_warning_desc: 'Les notifications push sont enregistrées mais non envoyées. Ajoutez VAPID_PUBLIC_KEY et VAPID_PRIVATE_KEY à vos variables d\'environnement.',
    push_send_title: 'Envoyer une Notification Push',
    push_title: 'Titre',
    push_message: 'Message',
    push_link_url: 'URL du Lien',
    push_target: 'Cible',
    push_target_all: 'Tous les Abonnés',
    push_target_company: 'Entreprise Spécifique',
    push_target_user: 'Utilisateur Spécifique',
    push_sending: 'Envoi en cours...',

    // Careers
    careers_join: 'Rejoignez Notre Équipe',
    careers_title: 'Carrières chez Whitewick IT',
    careers_subtitle: 'Construisez votre carrière avec une équipe passionnée qui redéfinit les services TI.',
    careers_life_title: 'La Vie chez Whitewick IT',
    careers_life_subtitle: 'Nous croyons que de grandes personnes construisent de grandes solutions. Voici pourquoi nos employés aiment travailler ici.',
    careers_positions_title: 'Postes Ouverts',
    careers_positions_count: 'poste disponible',
    careers_positions_count_plural: 'postes disponibles',
    careers_no_positions: 'Aucun poste ouvert pour le moment.',
    careers_no_positions_detail: 'Pas de postes ouverts actuellement, mais revenez bientôt!',
    careers_perk_health: 'Santé et Bien-être',
    careers_perk_health_desc: 'Couverture santé, dentaire et vision complète pour vous et votre famille.',
    careers_perk_growth: 'Croissance et Apprentissage',
    careers_perk_growth_desc: 'Budget annuel de développement professionnel et certifications supportées.',
    careers_perk_flex: 'Travail Flexible',
    careers_perk_flex_desc: 'Options hybrides et à distance avec des horaires flexibles.',
    careers_perk_balance: 'Équilibre Vie-Travail',
    careers_perk_balance_desc: 'Congés généreux, jours fériés payés et journées bien-être.',
    careers_perk_team: 'Équipe Formidable',
    careers_perk_team_desc: 'Équipe collaborative et solidaire avec des événements sociaux réguliers.',
    careers_perk_pay: 'Rémunération Compétitive',
    careers_perk_pay_desc: 'Rémunération leader du marché avec révisions annuelles et primes.',
    careers_job_full_time: 'Temps Plein',
    careers_job_part_time: 'Temps Partiel',
    careers_job_contract: 'Contrat',
    careers_job_internship: 'Stage',
    careers_description: 'Description',
    careers_requirements: 'Exigences',
    careers_benefits: 'Avantages',
    careers_close: 'Fermer',
    careers_apply_now: 'Postuler',
    careers_apply: 'Postuler',
    careers_submitted: 'Candidature Envoyée!',
    careers_thank_you: 'Merci pour votre candidature!',
    careers_confirm_email: 'Nous avons envoyé un courriel de confirmation. Notre équipe examinera votre candidature bientôt.',
    careers_full_name: 'Nom Complet',
    careers_phone: 'Téléphone',
    careers_cv: 'CV',
    careers_cv_upload: 'Téléverser CV (PDF, DOC, DOCX - max 10Mo)',
    careers_cv_required: 'Veuillez téléverser votre CV',
    careers_cover_letter: 'Lettre de Motivation (optionnel)',
    careers_cover_letter_upload: 'Téléverser lettre de motivation (optionnel)',
    careers_message: 'Message Additionnel (optionnel)',
    careers_message_placeholder: 'Dites-nous pourquoi ce poste vous intéresse...',
    careers_submit: 'Soumettre la Candidature',
    careers_submitting: 'Envoi en cours...',
    careers_success: 'Candidature soumise avec succès!',
    careers_error: 'Échec de la soumission',
    careers_error_generic: 'Erreur lors de la soumission',
    careers_name_email_required: 'Le nom et le courriel sont requis',
    careers_footer: 'Tous droits réservés.',

    // Common
    common_loading: 'Chargement...',
    common_error: 'Une erreur s\'est produite',
    common_success: 'Succès',
    common_cancel: 'Annuler',
    common_save: 'Enregistrer',
    common_delete: 'Supprimer',
    common_edit: 'Modifier',
    common_view: 'Voir',
    common_required: 'Requis',
  }
};

const LanguageContext = createContext(null);

// Detect browser language (returns 'en' or 'fr')
const detectBrowserLanguage = () => {
  // Check navigator.language and navigator.languages
  const browserLangs = navigator.languages 
    ? navigator.languages 
    : [navigator.language || navigator.userLanguage];
  
  for (const lang of browserLangs) {
    const langCode = lang.toLowerCase().split('-')[0]; // Get 'fr' from 'fr-CA', 'en' from 'en-US'
    if (langCode === 'fr') return 'fr';
    if (langCode === 'en') return 'en';
  }
  
  // Default to English if no match
  return 'en';
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Priority: 1. User's saved preference, 2. Browser language detection
    const saved = localStorage.getItem('language');
    if (saved) return saved;
    
    // No saved preference - detect from browser
    return detectBrowserLanguage();
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || translations['en'][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'fr' : 'en');
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
